import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { showEmeraldDialog } from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { AbortedError } from 'src/common/api/extended-emerald-error';
import { popEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';

export const showCashbackRequestDialog = async (): Promise<void> => {
  return new Promise<void>((resolve, reject) => {
    const modalConfig: IMessageModal = {
      subMessage: 'CashBackRequest_SubMessage',
      type: EmeraldDialogTypes.Info,
      message: 'CashBackRequest_Message',
      disableBackdropClick: true,
      acceptButtonLabel: 'Yes_CommandName',
      closeButtonLabel: 'No_CommandName',
      onAccept: () => resolve(),
      onCancel: () => reject(new AbortedError()),
    };
    showEmeraldDialog(modalConfig);
  }).finally(popEmeraldModal);
};
